import { createContext } from "react"
import Auth from "../Auth/Auth"

const AuthContext = createContext<Auth | null>(null)

export default AuthContext
